// src/api/chatService.ts
import apiClient from './config';

export const chatInit = async (reportId: string) => {
  try {
    const response = await apiClient.post('/chat/init', { report_id: reportId });
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.detail);
  }
};

export const chatMessage = async (sessionId: string, message: string) => {
  try {
    const response = await apiClient.post('/chat/message', { session_id: sessionId, message });
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.detail);
  }
};

export const chatRestart = async (sessionId: string) => {
  try {
    const response = await apiClient.post('/chat/restart', { session_id: sessionId });
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.detail);
  }
};

export const chatHistory = async (sessionId: string) => {
  try {
    const response = await apiClient.get(`/chat/history/${sessionId}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.detail);
  }
};
